import { Button, DrawerBody, DrawerFooter, } from '@one-thd/sui-atomic-components';
import React, { useEffect } from 'react';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { getWindow } from '../../../utils/general';
import '../../../styles/drawer.scss';
import { useCommonContext, useExperienceContext, } from '../../../hooks/useContexts';
export var BopisOutOfStockSurvey = function (_a) {
    var closeDrawer = _a.closeDrawer, orderId = _a.orderId, fulfillmentGroup = _a.fulfillmentGroup, fulfillmentType = _a.fulfillmentType, orderDetailsData = _a.orderDetailsData, customerType = _a.customerType, setIsSurvey = _a.setIsSurvey;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var isMobile = useCommonContext().isMobile;
    useEffect(function () {
        var timerId = setTimeout(function () {
            var _a, _b, _c, _d;
            if (((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.QSI) && ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.QSI.API)) {
                (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.QSI.API.load();
                (_d = getWindow()) === null || _d === void 0 ? void 0 : _d.QSI.API.run();
            }
        }, 100);
        return function () { return clearTimeout(timerId); };
    }, []);
    var closeDrawerOnClick = function () {
        setIsSurvey(false);
        closeDrawer();
    };
    var renderSurvey = function () {
        var _a, _b, _c, _d, _e;
        return (React.createElement("div", null,
            React.createElement("input", { type: "hidden", id: "orderNumberForBopisOutOfStock", value: orderId }),
            React.createElement("input", { type: "hidden", id: "orderOriginForBopisOutOfStock", value: orderDetailsData.orderOrigin }),
            React.createElement("input", { type: "hidden", id: "fulfillmentTypeForBopisOutOfStock", value: fulfillmentType }),
            React.createElement("input", { type: "hidden", id: "salesDateForBopisOutOfStock", value: orderDetailsData.salesDate }),
            React.createElement("input", { type: "hidden", id: "customerTypeForBopisOutOfStock", value: customerType }),
            React.createElement("input", { type: "hidden", id: "customerBillingZipForBopisOutOfStock", value: orderDetailsData.billingAddress.postalDetails.zipCode }),
            React.createElement("input", { type: "hidden", id: "appXPForBopisOutOfStock", value: isConsumerApp ? 'true' : 'false' }),
            React.createElement("input", { type: "hidden", id: "siteXPForBopisOutOfStock", value: isMobile ? 'mobile' : 'desktop' }),
            React.createElement("input", { type: "hidden", id: "oldStoreNumberForBopisOutOfStock", value: (_b = (_a = fulfillmentGroup.storePickup) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.number }),
            React.createElement("input", { type: "hidden", id: "oldStoreZipForBopisOutOfStock", value: (_e = (_d = (_c = fulfillmentGroup.storePickup) === null || _c === void 0 ? void 0 : _c.store) === null || _d === void 0 ? void 0 : _d.address) === null || _e === void 0 ? void 0 : _e.zipCode }),
            React.createElement("div", { id: "bopisOutOfStockXPsurvey", style: {
                    display: 'block',
                } })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerBody, null,
            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
                React.createElement(ErrorBoundary, { name: "bopis-out-of-stock-survey" }, renderSurvey()))),
        React.createElement(DrawerFooter, null,
            React.createElement(Button, { variant: "primary", onClick: closeDrawerOnClick }, "Go Back to Order Details"))));
};
